import type Ajv from 'ajv';
import { type Format } from 'ajv';
import { emailValidationPattern } from './email-validation';
import { validCurrency } from './currency-validation';
import { validLanguageCode } from './language-validation';
import { validTimeZone } from './timezone-validation';

export type CustomFormat =
  | 'phone'
  | 'color-hex'
  | 'currency'
  | 'language'
  | 'time-zone';

const newPhoneFormat = '^\\+[1-9]\\d{1,14}$';

export function addCustomFormats(
  ajv: Ajv,
  libraryBasedPhoneFieldValidationEnabled: Boolean,
) {
  const validationFormats = {
    ...customFormats,
    phone: libraryBasedPhoneFieldValidationEnabled
      ? newPhoneFormat
      : customFormats.phone,
  };
  for (const [name, format] of Object.entries(validationFormats)) {
    ajv.addFormat(name, format);
  }
}

// https://github.com/wix-private/wix-node-platform/tree/master/rpc/wnp-proto-validation-fv
const customFormats: { [name: string]: Format } = {
  phone: '^[\\d \\u00A0()+\\-.]+$',
  email: emailValidationPattern,
  'color-hex': /^#(?:[0-9A-F]{3,4}|[0-9A-F]{6}|[0-9A-F]{8})$/i,
  currency: validCurrency,
  language: validLanguageCode,
  'time-zone': validTimeZone,
};
